import type { TableController, TableState } from '@v2/table'
import './hand-controls.css'

export function HandControls({ hand, controller }: { hand: TableState['hand']; controller: TableController | null }) {
  if (!hand.zone) return null
  return <div className={`tt-hand-controls${hand.hidden ? ' is-folded' : ''}`} aria-label="Your private cards">
    {!hand.hidden && hand.zone.count === 0 && <div className="tt-hand-empty">Your hand is empty</div>}
    <div className="tt-hand-bar">
      <span className="tt-hand-private" title="Visible only to your seat" aria-label="Private hand">▱</span>
      <span className="tt-hand-count">Your hand <small>{hand.zone.count}</small></span>
      <button type="button" className="tt-hand-fold" aria-label={hand.hidden ? 'Show your hand' : 'Lower your hand'} title={hand.hidden ? 'Show your hand' : 'Lower your hand to see the table'} onClick={() => controller?.toggleHand()}>{hand.hidden ? '⌃' : '⌄'}</button>
    </div>
  </div>
}
